import { LibraryRoutes } from '@library/library-routes.mock';

import { MockPath } from '@library/common/http/mock-path.mock';

/* Order matters for the routes, first match is returned, match is RegExp based */
export const Routes: MockPath<unknown>[] = [
   // App specific

   // Library
   ...LibraryRoutes,
];
